import Seo from '../components/Seo';
import Marquee from '../components/Marquee';
import { T } from '../i18n/copy';
import Hero from '../components/home/Hero';
import PointOfView from '../components/home/PointOfView';
import Outcomes from '../components/home/Outcomes';
import ValueAreas from '../components/home/ValueAreas';
import TransitionBand from '../components/home/TransitionBand';
import HowWeWork from '../components/home/HowWeWork';
import Principles from '../components/home/Principles';
import About from '../components/home/About';
import Approach from '../components/home/Approach';
import ClinicSection from '../components/home/ClinicSection';
import FinalCta from '../components/home/FinalCta';

export default function Home({ lang }) {
  return (
    <>
      <Seo lang={lang} title={T.meta.home.title[lang]} description={T.meta.home.desc[lang]} />
      <Hero lang={lang} />
      <PointOfView lang={lang} />
      <Outcomes lang={lang} />
      <ValueAreas lang={lang} />
      <Marquee lang={lang} />
      <TransitionBand />
      <HowWeWork lang={lang} />
      <Principles lang={lang} />
      <About lang={lang} />
      <Approach lang={lang} />
      <ClinicSection lang={lang} />
      <FinalCta lang={lang} />
    </>
  );
}
